const modalsDefaultState = {
    foodItem: false,
    customPizza: false,
    pizza: false,
    special: false,
    cart: false,
    cartDelivery: false
};

export default (state = modalsDefaultState, action) => {
    switch (action.type) {

        case 'OPEN_FOOD_ITEM_MODAL':
            return {
                ...state,
                foodItem: true
            };

        case 'CLOSE_FOOD_ITEM_MODAL':
            return {
                ...state,
                foodItem: false
            };

        case 'OPEN_PIZZA_MODAL':
            return {
                ...state,
                pizza: true
            };

        case 'CLOSE_PIZZA_MODAL':
            return {
                ...state,
                pizza: false
            };

        case 'OPEN_CUSTOM_PIZZA_MODAL':
            return {
                ...state,
                customPizza: true
            };

        case 'CLOSE_CUSTOM_PIZZA_MODAL':
            return {
                ...state,
                customPizza: false
            };

        case 'OPEN_SPECIAL_MODAL':
            return {
                ...state,
                special: true
            };

        case 'CLOSE_SPECIAL_MODAL':
            return {
                ...state,
                special: false
            };

        case 'OPEN_CART_MODAL':
            return {
                ...state,
                cart: true
            };

        case 'CLOSE_CART_MODAL':
            return {
                ...state,
                cart: false
            };

        case 'OPEN_CART_DELIVERY_MODAL':
            return {
                ...state,
                cartDelivery: true
            };

        case 'CLOSE_CART_DELIVERY_MODAL':
            return {
                ...state,
                cartDelivery: false
            };

        case 'RESET_MODALS':
            return modalsDefaultState;

        default:
            return state;
    }
};